import React from "react";

const TalentCard = ({ name, role, image, socials, darkTheme = true }) => {
  const cardBg = darkTheme ? "#111" : "#fff";
  const textPrimary = darkTheme ? "#fff" : "#111";
  const textSecondary = darkTheme ? "#aaa" : "#666";
  const borderColor = darkTheme ? "#222" : "#e5e5e5";
  const shadow = darkTheme 
    ? "0 4px 20px rgba(0,0,0,0.4)" 
    : "0 4px 20px rgba(0,0,0,0.1)";

  return (
    <div style={{
      backgroundColor: cardBg,
      borderRadius: "12px",
      overflow: "hidden",
      width: "100%",
      maxWidth: "350px",
      transition: "all 0.4s ease",
      boxShadow: shadow,
      border: `1px solid ${borderColor}`,
      cursor: "pointer",
    }}>
      <div style={{
        position: "relative",
        width: "100%",
        height: "400px",
        overflow: "hidden",
      }}>
        <img
          src={image}
          alt={name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "all 0.4s ease",
          }}
        />
        <div className="overlay" style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.8) 100%)",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          padding: "2rem",
          opacity: 0,
          transition: "all 0.4s ease",
        }}>
          <div style={{
            display: "flex",
            gap: "1rem",
            flexWrap: "wrap",
            justifyContent: "center",
          }}>
            {socials && socials.map((handle, i) => {
              const cleanHandle = handle.replace('@', '');
              return (
                <a
                  key={i}
                  href={`https://instagram.com/${cleanHandle}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#fff",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    padding: "0.5rem 1rem",
                    backgroundColor: "rgba(255, 0, 0, 0.8)",
                    borderRadius: "20px",
                    transition: "all 0.3s ease",
                  }}
                >
                  {handle}
                </a>
              );
            })}
          </div>
        </div>
      </div>
      <div style={{
        padding: "1.5rem",
        textAlign: "center",
      }}>
        <h3 style={{
          color: textPrimary,
          fontSize: "1.4rem",
          fontWeight: "700",
          marginBottom: "0.5rem",
          letterSpacing: "0.5px",
        }}>{name}</h3>
        <p style={{
          color: textSecondary,
          fontSize: "0.85rem",
          marginBottom: "1rem",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}>{role}</p>
        <div style={{
          width: "50px",
          height: "3px",
          backgroundColor: "#ff0000",
          margin: "0 auto",
        }}></div>
      </div>
    </div>
  );
};

export default TalentCard;